import React, { useState, useContext, useEffect } from "react";
import { Form } from "semantic-ui-react";
import Result from "../../../../common/repository/Result";
import { toast } from "../../../common/Toast";
import PaymentSectionRepository from "../../../../common/repository/PaymentSectionRepository";

function UploadBulkPaymentForm({ onSuccess }: Props) {
  const [isLoading, setIsLoading] = useState(false);
  const [file, setFile] = useState<File | null>(null);
  const paymentRepo = new PaymentSectionRepository();

  useEffect(() => {
    uploadSheet();
  }, [isLoading, file]);

  return (
    <Form loading={isLoading}>
      <Form.Input
        type="file"
        label="Choose Payment Template Sheet"
        accept=".xlsx"
        onChange={(e) => {
          if (e.target.files) setFile(e.target.files[0]);
          else setFile(null);
        }}
      />
      <Form.Button
        positive
        disabled={isLoading || file === null}
        onClick={() => setIsLoading(true)}
      >
        Submit
      </Form.Button>
    </Form>
  );

  async function uploadSheet() {
    if (!isLoading || file === null) return;
    const result = await paymentRepo.uploadPaymentPendencySheet(file);
    if (result instanceof Result.Success) {
      if (result.data.items.length == 0)
        toast.success("Receipts uploaded successfully");
      else {
        toast.success(
          "Receipts uploaded successfully, But some rows are skipped!"
        );
      }

      if (onSuccess) onSuccess(result.data.items);
    } else {
      const message = result.message || "Something went wrong";
      toast.error(message);
    }
    setIsLoading(false);
  }
}

interface Props {
  onSuccess?(items: any): any;
}

export default UploadBulkPaymentForm;
